<template>
    <DModal
        :show="showModal"
        :is-awaiting-validation="true"
        :title="__('tools.testing.snapshots.edit.modal.title')"
        :message="__('tools.testing.snapshots.edit.modal.message', {'snapshot': item})"
        is-confirm
        @close="close"
        @confirm="confirm"
    >
        <div class="modal-content px-4 mb-4">
            <DFormRow
                :label="__('tools.testing.snapshots.edit.modal.form.name')"
                :error="errors?.name"
                :hint="__('tools.testing.snapshots.edit.modal.form.name_hint')"
            >
                <DInput
                    id="name"
                    v-model="form.name"
                />
            </DFormRow>
        </div>
    </DModal>
</template>

<script setup>

import { __ } from '~@/Composables/translation'
import { ref } from 'vue'
import { useForm } from '@inertiajs/vue3'

const props = defineProps({
    showModal: {
        type: Boolean,
        default: false
    },
    item: {
        type: String,
        default: ''
    },
    displayName: {
        type: String,
        default: ''
    },
    errors: {
        type: Object,
        default: () => { return {} }
    }
})

const itemRef = ref(props.item)
const emit = defineEmits(['close', 'confirm'])

const form = useForm({
    name: props.displayName,
})

function confirm () {
    emit('confirm', itemRef.value, form.name)
}

function close () {
    emit('close')
    form.reset()
}
</script>

<style lang="scss" scoped>
.modal-content {
    box-shadow: none;
}

.modal-content h2, .modal-content p {
    color: var(--cui-body-color);
    opacity: 0.6;
}
</style>
